import { buildSoteriaSyncedAttendance } from "./attendanceViewDataUtils";

export default function useAttendanceSoteriaSync({
    currentDate,
    dailyAttendance,
    getSoteriaAttendees,
    openAlert,
    setDailyAttendance,
    targetList,
}) {
    const handleSyncSoteria = async () => {
        const attendees = await getSoteriaAttendees(currentDate);

        if (!attendees) {
            openAlert("데이터를 가져오는 중 오류가 발생했습니다.", "오류");
            return;
        }

        if (attendees.length === 0) {
            openAlert("해당 날짜에 기록된 QR 출석 데이터가 없습니다.", "알림");
            return;
        }

        const { syncedAttendance, matchCount } = buildSoteriaSyncedAttendance({
            attendees,
            dailyAttendance,
            targetList,
        });

        setDailyAttendance(syncedAttendance);
        openAlert(`SOTERIA QR 출석 데이터와 동기화되었습니다.\n(총 ${attendees.length}명 중 ${matchCount}명 매칭 성공)`, "동기화 완료");
    };

    return { handleSyncSoteria };
}
